module.exports = __webpack_public_path__ + "img/text_wd1.c4ab1d81.png";